import { Auth } from 'aws-amplify';

export function userSignUp(email, password) {
  return Auth.signUp({
    username: email,
    password,
    attributes: {
      email,
    },
    autoSignIn: {
      enabled: true,
    }
  });
}

export function userConfirmSignUp(username, code) {
  return Auth.confirmSignUp(username, code);
}

export function userResendVerificationCode(username) {
  return Auth.resendSignUp(username);
}

export function userSignIn(username, password) {
  return Auth.signIn(username, password);
}

export function userSignOut() {
  return Auth.signOut();
}

export function getUserCurrentSession() {
  return Auth.currentSession();
}

export function getUserCurrentlyAuthenticated() {
  return Auth.currentAuthenticatedUser();
}

export function userForgotPassword(username) {
  return Auth.forgotPassword(username);
}

export function userForgotPasswordSubmit(username, code, new_password) {
  return Auth.forgotPasswordSubmit(username, code, new_password)
}

export function changeUserPassword(user, currentPassword, newPassword) {
  return Auth.changePassword(user, currentPassword, newPassword);
}